import { Controller } from "@hotwired/stimulus"

// Manejo dinámico de filas de items en la vista de validación.
// - "Agregar" clona el template con NEW_IDX reemplazado por timestamp
// - "Eliminar" marca _destroy=1 si es item persistido, o quita la fila si es nuevo
export default class extends Controller {
  static targets = ["tbody", "template", "row", "destroy"]

  add() {
    const newIdx = "new_" + Date.now() + Math.floor(Math.random() * 1000)
    const html = this.templateTarget.innerHTML.replaceAll("NEW_IDX", newIdx)
    this.tbodyTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    const row = event.target.closest("tr")
    if (!row) return
    const idInput = row.querySelector('input[name$="[id]"]')

    if (idInput && idInput.value) {
      // Item persistido → marcar para destroy + ocultar
      const destroyInput = row.querySelector('[data-item-rows-target="destroy"]')
      if (destroyInput) destroyInput.value = "1"
      row.style.display = "none"
    } else {
      // Item nuevo → quitar del DOM
      row.remove()
    }
  }
}
